import { differenceInCalendarDays } from 'date-fns';

/**
 * Returns the number of calendar days between today and the updated at date.
 * Compares only the date portion (YYYY-MM-DD) to avoid timezone-related discrepancies.
 */
export const getDatasetAgeDays = (updatedAt: string): number =>
  differenceInCalendarDays(
    new Date(new Date().toISOString().slice(0, 10)),
    new Date(updatedAt.slice(0, 10)),
  );
